import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SUPPORTED_LNGS, DEFAULT_LNG } from '../../i18n';

// Segmented EN | ES control for the nav. Each option is a real <Link> to the
// SAME page in that locale (path-preserving), so switching keeps the visitor in
// place, lands them on the correct per-locale URL, and stays crawlable. Derives
// the active locale from the URL itself — the source of truth for which locale
// page you're on.

const LABELS = { en: 'EN', es: 'ES' };
const NAMES = { en: 'English', es: 'Español' };

// "/es/pricing" -> "/pricing" · "/es" -> "/" · "/pricing" -> "/pricing"
function stripLocale(pathname) {
  const seg = pathname.split('/')[1];
  if (SUPPORTED_LNGS.includes(seg) && seg !== DEFAULT_LNG) {
    const rest = pathname.slice(seg.length + 1);
    return rest === '' ? '/' : rest;
  }
  return pathname || '/';
}

function localeHref(basePath, lng) {
  if (lng === DEFAULT_LNG) return basePath;
  return basePath === '/' ? `/${lng}` : `/${lng}${basePath}`;
}

export default function LocaleSwitcher({ className = '' }) {
  const { pathname, search, hash } = useLocation();
  const seg = pathname.split('/')[1];
  const active = SUPPORTED_LNGS.includes(seg) ? seg : DEFAULT_LNG;
  const base = stripLocale(pathname);

  // Only worth showing once there's a choice to make.
  if (SUPPORTED_LNGS.length < 2) return null;

  return (
    <div className={`rs-locale ${className}`.trim()} role="group" aria-label="Language">
      {SUPPORTED_LNGS.map((lng) => (
        <Link
          key={lng}
          to={`${localeHref(base, lng)}${search}${hash}`}
          className={`rs-locale-opt ${lng === active ? 'is-active' : ''}`}
          hrefLang={lng}
          aria-current={lng === active ? 'true' : undefined}
          aria-label={NAMES[lng] || lng}
          title={NAMES[lng] || lng}
        >
          {LABELS[lng] || lng.toUpperCase()}
        </Link>
      ))}
    </div>
  );
}
